import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export const ToolLayout = ({
  title,
  description,
  category,
  icon: Icon,
  children
}) => {
  return (
    <div className="min-h-screen bg-gradient-subtle">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          {category && (
            <Badge className="mb-4" variant="outline">
              {category}
            </Badge>
          )}

          {(title || description) && (
            <div className="flex items-center gap-4 mb-4">
              {Icon && (
                <div className="flex items-center justify-center w-16 h-16 rounded-xl bg-primary/10 text-primary">
                  <Icon className="w-8 h-8" />
                </div>
              )}

              <div>
                {title && (
                  <h1 className="text-3xl sm:text-4xl font-display font-bold text-foreground">
                    {title}
                  </h1>
                )}
                {description && (
                  <p className="text-lg text-muted-foreground mt-2">
                    {description}
                  </p>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">{children}</div>

          <div className="lg:col-span-1">
            <Card>
              <CardHeader>
                <CardTitle>Coming Soon</CardTitle>
                <CardDescription>
                  This calculator is currently under development.
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">
                  We're working hard to bring you accurate and easy-to-use
                  financial calculators. In the meantime, explore our other
                  available tools.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};
